// Logic & Fulfillment Tour
// Order fulfillment rules, shipping and post-purchase delivery
// Selector policy: step 1 pins to the live-verified sidebar id (#sb_payments); teaching steps are
// deliberate centered cards — no guessed element selectors.

export const logicFulfillmentTour = {
  id: 'logic-fulfillment',
  name: 'Logic & Fulfillment Tour',
  displayName: 'Deliver What You Sold',
  description: 'Order fulfillment rules, shipping and post-purchase delivery',
  estimatedDuration: '3 minutes',
  category: 'feature',
  autoStart: false,
  prerequisiteTours: ['ftux'],

  config: { animate: true, overlayOpacity: 0.75, smoothScroll: true, allowClose: true, showProgress: true },

  steps: [
    {
      element: '#sb_payments',
      popover: {
        title: "📦 Welcome to Fulfillment",
        description: `
          Taking the payment is half the job. **Fulfillment** is what happens next — delivering the product, granting the access, shipping the box.
        `,
        side: 'right',
        align: 'center'
      }
    },

    {
      popover: {
        title: "⚙️ Fulfillment Rules",
        description: `
          Define what a purchase should trigger. A digital product grants access; a physical one needs picking and shipping; a service needs a booking or a task for a human.
        `,
        side: 'over',
        align: 'center'
      }
    },

    {
      popover: {
        title: "🚚 Shipping & Delivery",
        description: `
          Set your **shipping origin** and rates so checkout quotes correctly. Wrong shipping at checkout is a top cause of abandoned carts and margin surprises.
        `,
        side: 'over',
        align: 'center'
      }
    },

    {
      popover: {
        title: "💰 Miscellaneous Charges",
        description: `
          Handle the extras deliberately — setup fees, handling, surcharges — so the total the customer sees matches what you intend to collect.
        `,
        side: 'over',
        align: 'center'
      }
    },

    {
      popover: {
        title: "🤖 Automate the Handoff",
        description: `
          A payment event should start fulfilment automatically: grant course access, create a task, notify the person who ships. Manual fulfilment is where orders get forgotten.
        `,
        side: 'over',
        align: 'center'
      }
    },

    {
      popover: {
        title: "📨 Tell the Customer",
        description: `
          Confirmation and delivery updates prevent the "where is my order?" message. A receipt plus one status update removes most support contacts.
        `,
        side: 'over',
        align: 'center'
      }
    },

    {
      popover: {
        title: "🎉 Sold and Delivered",
        description: `
          You can now:

✅ Define what each purchase triggers
✅ Quote shipping correctly
✅ Handle extra charges cleanly
✅ Automate fulfilment and updates

**Next:** buy one of your own products and follow the fulfilment path end to end.
        `,
        side: 'over',
        align: 'center',
        showButtons: ['close'],
        doneBtnText: 'Done →'
      }
    }
  ]
};
